/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalEhrDocuments } from './ExternalEhrDocuments';
import {
    ExternalEhrDocumentsFromJSON,
    ExternalEhrDocumentsFromJSONTyped,
    ExternalEhrDocumentsToJSON,
    ExternalEhrDocumentsToJSONTyped,
} from './ExternalEhrDocuments';
import type { UploadExternalEhrDocumentsRequest } from './UploadExternalEhrDocumentsRequest';
import {
    UploadExternalEhrDocumentsRequestFromJSON,
    UploadExternalEhrDocumentsRequestFromJSONTyped,
    UploadExternalEhrDocumentsRequestToJSON,
    UploadExternalEhrDocumentsRequestToJSONTyped,
} from './UploadExternalEhrDocumentsRequest';
import type { ExternalEhrPatient } from './ExternalEhrPatient';
import {
    ExternalEhrPatientFromJSON,
    ExternalEhrPatientFromJSONTyped,
    ExternalEhrPatientToJSON,
    ExternalEhrPatientToJSONTyped,
} from './ExternalEhrPatient';
import type { PccPatientCarePeriod } from './PccPatientCarePeriod';
import {
    PccPatientCarePeriodFromJSON,
    PccPatientCarePeriodFromJSONTyped,
    PccPatientCarePeriodToJSON,
    PccPatientCarePeriodToJSONTyped,
} from './PccPatientCarePeriod';
import type { PccPatientContact } from './PccPatientContact';
import {
    PccPatientContactFromJSON,
    PccPatientContactFromJSONTyped,
    PccPatientContactToJSON,
    PccPatientContactToJSONTyped,
} from './PccPatientContact';
import type { PccPatientOrganizationDetails } from './PccPatientOrganizationDetails';
import {
    PccPatientOrganizationDetailsFromJSON,
    PccPatientOrganizationDetailsFromJSONTyped,
    PccPatientOrganizationDetailsToJSON,
    PccPatientOrganizationDetailsToJSONTyped,
} from './PccPatientOrganizationDetails';
import type { PccPatientCondition } from './PccPatientCondition';
import {
    PccPatientConditionFromJSON,
    PccPatientConditionFromJSONTyped,
    PccPatientConditionToJSON,
    PccPatientConditionToJSONTyped,
} from './PccPatientCondition';
import type { PccPatientAllergy } from './PccPatientAllergy';
import {
    PccPatientAllergyFromJSON,
    PccPatientAllergyFromJSONTyped,
    PccPatientAllergyToJSON,
    PccPatientAllergyToJSONTyped,
} from './PccPatientAllergy';

/**
 * 
 * @export
 * @interface PccAdvancedPatientDetails
 */
export interface PccAdvancedPatientDetails {
    /**
     * 
     */
    external_ehr_patient?: ExternalEhrPatient;
    /**
     * 
     */
    care_period?: PccPatientCarePeriod;
    /**
     * 
     */
    organization_details?: PccPatientOrganizationDetails;
    /**
     * 
     */
    contacts?: Array<PccPatientContact>;
    /**
     * 
     */
    allergies?: Array<PccPatientAllergy>;
    /**
     * 
     */
    conditions?: Array<PccPatientCondition>;
    /**
     * 
     */
    documents?: ExternalEhrDocuments;
    /**
     * 
     */
    upload_documents_request?: UploadExternalEhrDocumentsRequest;
    /**
     * 
     */
    upload_to_pcc?: boolean;
}

/**
 * Check if a given object implements the PccAdvancedPatientDetails interface.
 */
export function instanceOfPccAdvancedPatientDetails(value: object): value is PccAdvancedPatientDetails {
    return true;
}

export function PccAdvancedPatientDetailsFromJSON(json: any): PccAdvancedPatientDetails {
    return PccAdvancedPatientDetailsFromJSONTyped(json, false);
}

export function PccAdvancedPatientDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccAdvancedPatientDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'external_ehr_patient': json['external_ehr_patient'] == null ? undefined : ExternalEhrPatientFromJSON(json['external_ehr_patient']),
        'care_period': json['care_period'] == null ? undefined : PccPatientCarePeriodFromJSON(json['care_period']),
        'organization_details': json['organization_details'] == null ? undefined : PccPatientOrganizationDetailsFromJSON(json['organization_details']),
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(PccPatientContactFromJSON)),
        'allergies': json['allergies'] == null ? undefined : ((json['allergies'] as Array<any>).map(PccPatientAllergyFromJSON)),
        'conditions': json['conditions'] == null ? undefined : ((json['conditions'] as Array<any>).map(PccPatientConditionFromJSON)),
        'documents': json['documents'] == null ? undefined : ExternalEhrDocumentsFromJSON(json['documents']),
        'upload_documents_request': json['upload_documents_request'] == null ? undefined : UploadExternalEhrDocumentsRequestFromJSON(json['upload_documents_request']),
        'upload_to_pcc': json['upload_to_pcc'] == null ? undefined : json['upload_to_pcc'],
    };
}

export function PccAdvancedPatientDetailsToJSON(json: any): PccAdvancedPatientDetails {
    return PccAdvancedPatientDetailsToJSONTyped(json, false);
}

export function PccAdvancedPatientDetailsToJSONTyped(value?: PccAdvancedPatientDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'external_ehr_patient': ExternalEhrPatientToJSON(value['external_ehr_patient']),
        'care_period': PccPatientCarePeriodToJSON(value['care_period']),
        'organization_details': PccPatientOrganizationDetailsToJSON(value['organization_details']),
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(PccPatientContactToJSON)),
        'allergies': value['allergies'] == null ? undefined : ((value['allergies'] as Array<any>).map(PccPatientAllergyToJSON)),
        'conditions': value['conditions'] == null ? undefined : ((value['conditions'] as Array<any>).map(PccPatientConditionToJSON)),
        'documents': ExternalEhrDocumentsToJSON(value['documents']),
        'upload_documents_request': UploadExternalEhrDocumentsRequestToJSON(value['upload_documents_request']),
        'upload_to_pcc': value['upload_to_pcc'],
    };
}

